import React, { useState, useEffect } from 'react';
import { setCookie, getCookieSettings } from '../../utils/cookieUtils';

const CookieSettings = () => {
  const [cookieSettings, setCookieSettings] = useState({
    necessary: true, // Always required
    analytics: false,
    marketing: false,
    preferences: false
  });
  
  const [saved, setSaved] = useState(false);

  // Load saved settings when component mounts
  useEffect(() => {
    const savedSettings = getCookieSettings();
    if (savedSettings) {
      setCookieSettings(savedSettings);
    }
  }, []);

  // Handle checkbox change
  const handleSettingChange = (setting) => {
    setCookieSettings({
      ...cookieSettings,
      [setting]: !cookieSettings[setting]
    });
    setSaved(false);
  };

  // Save settings
  const saveSettings = () => {
    localStorage.setItem('cookieConsent', 'custom');
    localStorage.setItem('cookieSettings', JSON.stringify(cookieSettings));
    
    // Set a cookie for server-side tracking of consent
    setCookie('cookieConsent', 'custom', 365); // Valid for 1 year
    
    setSaved(true);
    
    // Show saved message for 3 seconds
    setTimeout(() => {
      setSaved(false);
    }, 3000);
  };

  return (
    <div className="bg-gray-900 p-6 rounded-lg max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold mb-6 text-white">Cookie Settings</h2>
      
      <div className="mb-6">
        <div className="mb-4">
          <label className="flex items-center cursor-not-allowed">
            <input
              type="checkbox"
              checked={cookieSettings.necessary}
              disabled
              className="mr-2"
            />
            <span className="font-semibold text-white">Necessary Cookies</span>
          </label>
          <p className="text-gray-400 text-sm ml-6">These cookies are required for the website to function properly.</p>
        </div>
        
        <div className="mb-4">
          <label className="flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={cookieSettings.analytics}
              onChange={() => handleSettingChange('analytics')}
              className="mr-2"
            />
            <span className="font-semibold text-white">Analytics Cookies</span>
          </label>
          <p className="text-gray-400 text-sm ml-6">Help us improve our website by collecting anonymous information.</p>
        </div>
        
        <div className="mb-4">
          <label className="flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={cookieSettings.marketing}
              onChange={() => handleSettingChange('marketing')}
              className="mr-2"
            />
            <span className="font-semibold text-white">Marketing Cookies</span>
          </label>
          <p className="text-gray-400 text-sm ml-6">Used to track your activity for personalised marketing.</p>
        </div>
        
        <div className="mb-4">
          <label className="flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={cookieSettings.preferences}
              onChange={() => handleSettingChange('preferences')}
              className="mr-2"
            />
            <span className="font-semibold text-white">Preference Cookies</span>
          </label>
          <p className="text-gray-400 text-sm ml-6">Remember your preferences and settings.</p>
        </div>
      </div>
      
      <div className="flex items-center">
        <button
          onClick={saveSettings}
          className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded-md"
        >
          Save Preferences
        </button>
        
        {saved && (
          <span className="ml-4 text-green-400">
            Settings saved successfully!
          </span>
        )}
      </div>
    </div>
  );
};

export default CookieSettings; 